<template>
  <div class="providers-grid">
    <div v-for="p in providers" :key="p.name" class="pv-tile" :class="{ 'pv-tile--self': !!p.icon }">
      <LogoTile :logo="p.logo" :icon="p.icon" :alt="p.name + ' logo'" :size="46" />
      <span class="pv-name">{{ p.name }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import LogoTile from './LogoTile.vue'
import { providers, Provider } from './landingContent'

@Options({
  components: { LogoTile }
})
export default class ProviderGrid extends Vue {
  providers: Provider[] = providers
}
</script>

<style scoped lang="scss">
.providers-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 40px;
}
.pv-tile {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: rgb(var(--v-theme-background));
  border: 1px solid var(--l-border);
  border-radius: 12px;
}
.pv-tile--self {
  border-style: dashed;
}
.pv-name {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.005em;
}
@media (max-width: 900px) {
  .providers-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 560px) {
  .providers-grid {
    grid-template-columns: 1fr;
  }
}
</style>
